import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import store from '@pt/store';
import { getToken } from '@pt/utils/auth';
import { localLanguage } from '@/common/storage';
import { routerWhiteList } from '@pt/config/router';

export default {
  data: function data() {
    return {
      // 因为用户容量在全局都会用到，因此每 10 秒会请求一次用户容量, 只有登录后才轮询
      pollGetUsageStatus: true
    };
  },

  computed: {
    lang: function lang() {
      switch (localLanguage.get()) {
        case 'en':
          return 'en';
        case 'ja':
          return 'ja';
        default:
          return 'zh';
      }
    },
    className: function className() {
      return 'app-lang-' + this.lang;
    }
  },
  mounted: function mounted() {
    var _this = this;

    var path = location.href.split('#')[1];
    var pollGetList = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var timer;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(getToken() && routerWhiteList.indexOf(path) === -1)) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return store.dispatch('assets/uploader/getAssetsUsage');

              case 3:

                // 如果没有登录的话，100ms 轮询一次，如果登录的话， 10s 再轮询
                timer = getToken() ? 10000 : 100;


                setTimeout(function () {
                  if (_this.pollGetUsageStatus && store.state.assets.uploader.freeSize !== -1) {
                    pollGetList();
                  }
                }, timer);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function pollGetList() {
        return _ref.apply(this, arguments);
      };
    }();
    pollGetList();
  },
  beforeDestroy: function beforeDestroy() {
    this.pollGetUsageStatus = false;
  }
};